/**
 * Created by Bob.Gear on 24/05/14.
 */
/**
 * Created by Bob.Gear on 11/03/14.
 */
//------------------------------------------------------------------------
//  contractStageFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('contractStageFilterController', ['$scope', 'lookupTables',
      function ($scope, lookupTables) {
        $scope.componentName = "contractStageFilter";

        $scope.contractStages = lookupTables.contractStages();

        $scope.resetFilter = function () {
          $scope.clearContractStageSelections();
        };

        $scope.clearContractStageSelections = function () {
          $scope.criteria.selectedContractStages = null;
          delete $scope.criteria["selectedContractStages"];
        };

        $scope.removeContractStageFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#contractStageFilter");
        };

        $scope.$watch("criteria.selectedContractStages.length", function () {
          if (!$scope.criteria.selectedContractors) return;

          $scope.selectedCount = $scope.criteria.selectedContractStages.length;
          $scope.plural = ($scope.selectedCount === 1) ? "" : "s";
        });

      }])
    .directive('contractStageFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div projectNameFilter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/contractStageFilter.tmpl.html",

          link: function ($scope, iElement, iAttrs) {
          },

          controller: 'contractStageFilterController'
        };
      }]);
//------------------------------------------------------------------------
